export default __webpack_public_path__ + "static/media/svg-1.3d57036f.svg";